import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

import ShopBy from './ShopGrid/ShopBy';
import ProductCard from './ShopGrid/ProductCard';
import Layout from '../../ui/Layout';
import Loading from '../../ui/Loading';
import MetaTags from 'react-meta-tags';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/cart-header-dux';
import MetaLoader from '../../ui/MetaLoader';

const IS_HOLIDAY = process.env.REACT_APP_SHOP_ISHOLIDAY === 'true';

class CustomToggle extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }
  render() {
    return (
      <a href="" className="sort-by" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

const sortProducts = sortBy =>
  (
    { sellableUnits: selA, DisplayOrder: displayOrderA, Name: nameA },
    { sellableUnits: selB, DisplayOrder: displayOrderB, Name: nameB }
  ) => {
    if (sortBy === 'price-hl') {
      const a = selA[0].unitPrice;
      const b = selB[0].unitPrice;
      return b - a;
    }
    if (sortBy === 'price-lh') {
      const a = selA[0].unitPrice;
      const b = selB[0].unitPrice;
      return a - b;
    }
    if (sortBy === 'featured') {
      if (displayOrderA === displayOrderB) return 0;
      if (displayOrderA === null) return 1;
      if (displayOrderB === null) return -1;
      return displayOrderA - displayOrderB;
    }
    return 0;
  };

const getVarietalIdByParameter = param => {
  switch (param) {
    case 'pinot-noir':
      return 'Pinot Noir';
    case 'sauvignon-blanc':
      return 'Sauvignon Blanc';
    case 'rose':
      return 'Rosé';
    case 'wines':
      return 'All Varietals';
    default:
      return null;
  }
};

const getCategoryIdByParameter = param => {
  switch (param) {
    case 'ava-wines':
      return 1;
    case 'single-vineyard-wines':
      return 2;
    case 'exclusive-offers':
      return 3;
    case 'holiday-offers':
      return 23;
    // case 'merchandise':
    // return 4;
    case 'events':
      return 6;
    default:
      return null;
  }
};

const getCategoryLabelByParameter = param => {
  switch (param) {
    case 'ava-wines':
      return 'AVA Wines';
    case 'single-vineyard-wines':
      return 'Single Vineyard Wines';
    // case 'exclusive-offers':
    //   return 'Exclusive Offers';
    case 'holiday-offers':
      return 'Holiday Offers';
    // case 'merchandise':
    //   return 'Merchandise';
    case 'events':
      return 'Events';
    default:
      return null;
  }
};

const getSortByLabel = label => {
  switch (label) {
    case 'price-hl':
      return 'Sort by Price (High to Low)';
    case 'price-lh':
      return 'Sort by Price (Low to High)';
    case 'featured':
      return 'Sort by Featured';
    default:
      return '';
  }
};

const FILTER_TYPES = {
  NONE: 0,
  VARIETAL: 1,
  CATEGORY: 2
};

const filterProducts = (filterType, param) =>
  ({ wineDetails, categories, ProductTypeID, hasAlcohol }) => {
    if (filterType === FILTER_TYPES.NONE) return true;
    if (filterType === FILTER_TYPES.VARIETAL) {
      const { Varietal } = wineDetails || {};
      const vid = getVarietalIdByParameter(param);
      if (vid === 'All Varietals') return hasAlcohol || ProductTypeID === 1;
      return Varietal === vid;
    }
    const categoryId = getCategoryIdByParameter(param);
    return (categories || [])
      .some(({ productCategoryId }) => productCategoryId === categoryId);
  };

const getFilterType = param => {
  if (!param) return FILTER_TYPES.NONE;
  const isVarietal = getVarietalIdByParameter(param) !== null;
  const isCategory = getCategoryIdByParameter(param) !== null;

  return isVarietal
    ? FILTER_TYPES.VARIETAL
    : isCategory ? FILTER_TYPES.CATEGORY : FILTER_TYPES.NONE;
};

const getFilterLabel = (filterType, param) => {
  if (filterType === FILTER_TYPES.VARIETAL)
    return getVarietalIdByParameter(param);
  if (filterType === FILTER_TYPES.CATEGORY)
    return getCategoryLabelByParameter(param);
  return 'All Products';
};

const getMetaVars = filter => {
  // switch cases for each filter case meta data
  switch (filter) {
    case 'pinot-noir':
      return {
        metaTitle: 'Shop Our Pinot Noir Wines | Twomey',
        metaDescription: `Shop TWOMEY's vineyard-focused Pinot Noir wines here. Limited quantities and Club Member pricing available here.`,
        metaUrl: 'https://twomey.com/shop/pinot-noir/'
      };
    case 'sauvignon-blanc':
      return {
        metaTitle: 'Shop Our Sauvignon Blanc Wines | Twomey',
        metaDescription: `Shop TWOMEY Sauvignon Blanc wines, sourced exclusively from estate-owned vineyards in the Napa Valley and Russian River Valley.`,
        metaUrl: 'https://twomey.com/shop/sauvignon-blanc/'
      };
    case 'rose':
      return {
        metaTitle: 'Shop Our Rosé Wines | Twomey',
        metaDescription: `Shop TWOMEY Sauvignon Blanc wines, sourced exclusively from estate-owned vineyards in the Napa Valley and Russian River Valley.`,
        metaUrl: 'https://twomey.com/shop/rose/'
      };
    case 'ava-wines':
      return {
        metaTitle: 'Shop AVA Wines | Twomey',
        metaDescription: `Shop TWOMEY AVA wines that showcase the character and quality of the Russian River Valley and Anderson Valley AVAs.`,
        metaUrl: 'https://twomey.com/shop/ava-wines/'
      };
    case 'single-vineyard-wines':
      return {
        metaTitle: 'Shop Our Single Vineyard Wines | Twomey',
        metaDescription: `Shop TWOMEY single vineyard wines from California's North and Central Coasts and Willamette Valley.`,
        metaUrl: 'https://twomey.com/shop/single-vineyard-wines/'
      };
    // case 'exclusive-offers':
    //   return {
    //     metaTitle: IS_HOLIDAY
    //       ? 'Shop Holiday Offers | Twomey'
    //       : 'Shop Winery Exclusives | Twomey',
    //     metaDescription: IS_HOLIDAY
    //       ? 'Shop winery exclusive holiday offers and Club Member priority access to limited availability TWOMEY wine offerings.'
    //       : `Shop winery exclusive offers and Member priority access to limited availability TWOMEY wines.`,
    //     metaUrl: 'https://twomey.com/shop/exclusive-offers/'
    //   };
    case 'events':
      return {
        metaTitle: 'Shop Wine Events | Twomey',
        metaDescription: `Attending an upcoming TWOMEY wine event? Purchase your tickets here.`,
        metaUrl: 'https://twomey.com/shop/events/'
      };
    default:
      return {
        metaTitle: 'Shop Our Wines | Twomey',
        metaDescription: `Shop new and exclusive Pinot Noir and Sauvignon Blanc. Shop by wine or by category, such as Single Vineyard or AVA wines.`,
        metaUrl: 'https://twomey.com/shop'
      };
  }
};

class ShopGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { sortBy: 'featured' };
  }
  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.getShopProducts();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-grid',
      'page-template-page-templatesshop-template-grid-php',
      'page',
      'page-id-214',
      'page-child',
      'parent-pageid-212',
      'no-sidebar',
      'headroom',
      'loaded',
      'nav-closed',
      'desktop-device',
      'headroom--not-bottom',
      'headroom--pinned',
      'headroom--top'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-grid',
      'page-template-page-templatesshop-template-grid-php',
      'page',
      'page-id-214',
      'page-child',
      'parent-pageid-212',
      'no-sidebar',
      'headroom',
      'loaded',
      'nav-closed',
      'desktop-device',
      'headroom--not-bottom',
      'headroom--not-top',
      'headroom--unpinned'
    );
  }

  render() {
    const {
      user,
      products,
      loading,
      postAddToCart,
      setCartAdd,
      match: { params }
    } = this.props;

    const { sortBy } = this.state;
    const scrollToTop = () => window.scrollTo(0, 0);

    const { filter } = params || {};

    const filterType = getFilterType(filter);

    if (filter && filterType === FILTER_TYPES.NONE) return <Redirect to="/" />;

    const changeSortBy = value => () => this.setState({ sortBy: value });

    const displayProducts = (products || [])
      .filter(filterProducts(filterType, filter))
      .sort(sortProducts(sortBy));

    const {
      metaTitle,
      metaUrl,
      metaDescription
    } = getMetaVars(filter);

    return (
      <Layout>
        <MetaLoader title={metaTitle} />
        <MetaTags>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content={metaTitle} />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={metaUrl} />
          <meta property="og:description" content={metaDescription} />
          <meta
            property="og:image"
            content="https://cdn.twomey.com/shop/banner-twomey-shop.jpg"
          />
        </MetaTags>

        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero">
              <div className="container">

                <div className="row">
                  <div className="col-6">
                    <h1 className="h3-style column-header-alt grid-header">
                      {getFilterLabel(filterType, filter)}
                    </h1>
                  </div>
                  <div className="col-6 text-right">
                    <div className="shop-filters">

                      <Dropdown
                        alignRight
                        className="sort-by-dropdown sub-drop"
                      >
                        <Dropdown.Toggle as={CustomToggle} className="sort-by">
                          {getFilterLabel(filterType, filter)}
                          {' '}
                          <i className="fas fa-chevron-down" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-center">
                          <div className="dropdown-inner filter-drop">
                            <span>Variety</span>
                            <Link to="/shop/pinot-noir/">
                              Pinot Noir
                            </Link>
                            <Link to="/shop/sauvignon-blanc/">
                              Sauvignon Blanc
                            </Link>
                            <Link to="/shop/rose/">
                              Rosé
                            </Link>
                            <Link to="/shop/">
                              All Wines
                            </Link>
                            <span>Category</span>
                            <Link to="/shop/ava-wines/">
                              AVA Wines
                            </Link>
                            <Link to="/shop/single-vineyard-wines/">
                              Single Vineyard Wines
                            </Link>
                            {/* {!IS_HOLIDAY && <Link to="/shop/exclusive-offers/">
                              Exclusive Offers
                            </Link>} */}
                            {IS_HOLIDAY && <Link to="/shop/holiday-offers/">
                              Holiday Offers
                            </Link>}
                            {/* <Link to="/merchandise">
                              Merchandise
                            </Link> */}
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>

                      <Dropdown
                        alignRight
                        className="sort-by-dropdown sub-drop"
                      >
                        <Dropdown.Toggle as={CustomToggle} className="sort-by">
                          {getSortByLabel(sortBy)}
                          {' '}
                          <i className="fas fa-chevron-down" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-center">
                          <div className="dropdown-inner filter-drop">
                            <a href="#" onClick={changeSortBy('price-hl')}>
                              Sort by Price (High to Low)
                            </a>
                            <a href="#" onClick={changeSortBy('price-lh')}>
                              Sort by Price (Low to High)
                            </a>
                            <a href="#" onClick={changeSortBy('featured')}>
                              Sort by Featured
                            </a>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>

                    </div>
                  </div>
                </div>

                <div className="row product-grid">

                  {loading && <Loading scrollToTop />}
                  {!loading &&
                    (displayProducts || []).length === 0 &&
                    <div className="col-sm-12">
                      <p className="bigger">
                        We are currently sold out of these offerings
                      </p>
                    </div>}

                  {!loading &&
                    (displayProducts || []).length !== 0 &&
                    (displayProducts || [])
                      .map((product, index) => (
                        <ProductCard
                          key={product.ProductID}
                          user={user}
                          product={product}
                          columns={'col-sm-6 col-lg-4'}
                          onAddToCart={postAddToCart}
                          setCartAdd={setCartAdd}
                        />
                      ))}

                </div>
              </div>
            </main>
          </div>

          <div className="container text-right">
            <div className="row justify-content-center">
              <div className="col-md-10 text-right">
                <a href="#" className="back-to-top" onClick={scrollToTop}>
                  Back to top
                </a>
              </div>
            </div>
          </div>

        </div>

      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error,
    inProgress,
    result: products
  } = state.getShopProducts.toJS();

  const {
    result: user
  } = state.postLogin.toJS();

  return {
    user,
    products,
    loading: inProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getShopProducts: fetchDux.getShopProducts.createAction,
      postAddToCart: fetchDux.postAddToCart.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ShopGrid);
